import React from 'react';

import WebinarListPageContainer from '@src/components/webinar/list/WebinarListPageContainer';

const WebinarListPage = () => <WebinarListPageContainer />;

export default WebinarListPage;
